<template>
  <pt-system-user-detail v-loading="loading" :detail="currentData"></pt-system-user-detail>
</template>

<script>
import PtSystemUserDetail from './index'
export default {
  name: 'pt-system-user-detail__withData',
  components: {
    'pt-system-user-detail': PtSystemUserDetail
  },
  data () {
    return {
      loading: false,
      currentData: {}
    }
  },
  methods: {
    load () {
      this.loading = true
      this.$store.dispatch('organizationUserInformation', this.$route.params.id).then(data => {
        this.loading = false
        this.currentData = data
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    }
  },
  created () {
    this.load()
  }
}
</script>
